module.exports = __webpack_public_path__ + "static/img/case_banner_13.34c8b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_13.png
// module id = aPpY
// module chunks = 34